import { AppPageRouteTypes, AppPagePaths, LegacyPagePaths } from "App/routes/paths";

export const TOP_LEVEL_PAGES_TITLE_MAP = {
    [AppPagePaths.fallback]: "/",
    [AppPagePaths.admin]: "Admin",

    [AppPagePaths.regalLive]: "Regal Live",
    [AppPagePaths.aiAgents]: "Agent Builder",
    [AppPagePaths.convoIntel]: "Conversation Intelligence",

    [AppPagePaths.orchestration]: "Orchestration",
    [AppPagePaths.audience]: "Audience",
    [AppPagePaths.liveOps]: "Live Ops",
    [AppPagePaths.agentDesktop]: "Agent Desktop",

    [AppPagePaths.copilot]: "Copilot",
    [AppPagePaths.reporting]: "Reporting",
    [AppPagePaths.settings]: "Settings",

    [AppPagePaths.journeysUsers]: "Journeys Users",
    [AppPagePaths.regalLiveAi]: "Regal Live",
} as const satisfies Partial<Record<AppPageRouteTypes, string>>;
// `satisfies` keeps literal key types and prevents JSX consumers from getting `string | undefined` errors.

export const LEGACY_PAGES_TITLE_MAP: Record<string, string> = {
    [LegacyPagePaths.phoneNumbers]: "Phone Numbers",
};

/**
 * Creates a consistent regex pattern for stripping a base path and optional trailing slash
 * from location.pathname in rerouter components.
 * @param basePath - The base path to strip (e.g., AppPagePaths.tasks)
 * @returns RegExp that matches the base path with optional trailing slash
 */
export const createRerouteRegex = (basePath: string): RegExp => {
    return new RegExp(`^${basePath}/?`);
};
